import { render } from "./CvssEval.vue?vue&type=template&id=4caa2ecb"
import script from "./CvssEval.vue?vue&type=script&lang=js"
export * from "./CvssEval.vue?vue&type=script&lang=js"

import "./CvssEval.vue?vue&type=style&index=0&id=4caa2ecb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__